
export class AbstractAnimationVO {
    public animationCompleteCallback: Function;
}
